import z from "zod";

/**
 * ChecklistMaquinaEquipSchema
 */

export const ChecklistMaquinaEquipSchema = z.object({
  idChecklistMaquinaEquip: z.number().optional(),
  status: z.coerce.number().default(0),
  codigo: z.string().nonempty('Este campo deve ser preenchido!'),
  nroRevisao: z.string().nonempty('Este campo deve ser preenchido!'),
  descricao: z.string().nonempty('Este campo deve ser preenchido!'),

});

/**
 * ChecklistMaquinaEquipForm
 */

export type ChecklistMaquinaEquipForm = z.infer<typeof ChecklistMaquinaEquipSchema>;

/**
 * initialChecklistMaquinaEquipForm
 */

export const initialChecklistMaquinaEquipForm: Partial<ChecklistMaquinaEquipForm> = {
  status: 0,

};